export default "__VITE_ASSET__DU867IRS__"